export default __webpack_public_path__ + "static/media/riskman.c0229d9c.png";